
import {
    TerminalContract,
    OpenAPI,
    TerminalContractsService
} from '../openapi';
import { PropertyInfo } from '../openapi/models/PropertyInfo';

const { put, get, post, delete: del, propertyInfo } = TerminalContractsService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getTerminalContractsByTerminalId = async (token: string, id: number): Promise<TerminalContract[]> => {
    return await get(token, id);
};

export const addTerminalContract = async (token: string, newTerminalContract: TerminalContract): Promise<TerminalContract> => {
    return await post(token, newTerminalContract);
};

export const updateTerminalContract = async (
    token: string,
    id: number,
    terminal: TerminalContract
): Promise<TerminalContract> => {
    return await put(token, id, terminal);
};

export const deleteTerminalContract = async (token: string, id: number) => {
    await del(token, id);
};

export const getPropertyInfo = async (token: string, poi: string): Promise<Record<string, PropertyInfo>> => {
    return await propertyInfo(token, poi);
};